import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarkerService {

  private markersSource = new BehaviorSubject<any[]>([]); // Holds the list of markers
  markers$ = this.markersSource.asObservable(); // Observable for tracking marker changes

  constructor() {}

  // Add a new marker
  addMarker(marker: any): void {
    const currentMarkers = this.markersSource.getValue();
    this.markersSource.next([...currentMarkers, marker]);
  }



  // Clear all markers and remove them from the map
  clearMarkers(): void {
    const currentMarkers = this.markersSource.getValue();

    currentMarkers.forEach(marker => {
      if (marker.setMap) {
        marker.setMap(null);
      }
    });

    this.markersSource.next([]);
  }
}
